import React, { useCallback, useEffect, useState } from "react";

import HeaderMenu from "./HeaderMenu/HeaderMenu";
import HeaderTop from "./HeaderTop/HeaderTop";
import { useRef } from "react";

const Header = () => {
  // const userAvailable = checkLocalStore("user");
  // const userLogout = removeLocalStore("user")
  const ref = useRef();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isOpen, setIsOpen] = useState(true);

  console.log(isOpen,"isOpenisOpen")

  const handleResize = useCallback(() => {
    setWindowWidth(window.innerWidth);
  });

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  return (
    <>
      <div className="header" ref={ref}>
        <HeaderTop
          setIsOpen={(e) => {
            setIsOpen(e);
          }}
          isOpen={isOpen}
        />
        <HeaderMenu
          windowWidth={windowWidth}
          setIsOpen={(e) => {
            setIsOpen(e);
          }}
          isOpen={isOpen}
        />
      </div>
    </>
  );
};

export default Header;
